<template>
  <el-autocomplete
    v-model="major"
    :fetch-suggestions="querySearchAsync"
    :placeholder="placeholder"
    :disabled="disabled"
    size="mini"
    clearable
    @select="onSelect"
    @clear="onClear" />
</template>
<script>

export default {
  name: 'LoveSearchMajor',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    selected: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      major: this.selected
    }
  },
  methods: {
    querySearchAsync(queryString, callback) {
        if(queryString) {
          this.$api.commonApi.commonIndex.listMajor({
                which: "name",
                like: queryString
            })
                .then(res=> {
                    let results = res.data.lists.map(item=> {
                        return {
                            id: item.id,
                            value: item.name,
                        }
                    })
                    callback(results);
                })
                .catch(err=> {
                    callback([]);
                })
        }
    },
    onSelect(val) {
        let results = {
            id: val.id,
            name: val.value,
        }
        this.$emit("change", results)
        console.log("val is ", results)
    },
    onClear() {
        this.$emit("change", undefined)
    },
    _reSetCascarder() {
        this.major = ''
    }
  },
  watch: {
    selected(val) {
      this.major = val
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/search/major.vue